import React, { useEffect, useState } from 'react'
import { FaTasks } from 'react-icons/fa';
import axiosAuthInstance from '../../../../utils/axios/axiosAuthInstance'
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { getPriorityColor } from '../../../../utils/Helper';
import { BiTask } from "react-icons/bi";

const PersonalTask = () => {
    const navigate = useNavigate()

    const [tasksList, setTaskList] = useState([]);
    const [taskStatus, setTaskStatus] = useState([])
    const [selectedStatus, setSelectedStataus] = useState({})

    const handleViewTask = (id) => {
        navigate(`/task/view/${id}`)
    }

    const fetchData = async () => {
        try {
            const response = await axiosAuthInstance.get('task/list',
                { sortPriority: true, limit: 30, isPersonal: true })

            if (response && response.status === 200) {
                setTaskList(response.data?.result?.docs)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const fetchTaskStatus = async () => {
        try {
            const response = await axiosAuthInstance.get('task-status/dropdown')
            if (response.status === 200) {
                const transformedData = response?.data?.result?.map((item) => ({
                    value: item._id,
                    label: `${item.name}`,
                }))
                setTaskStatus(transformedData)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const handleStatusChange = async (selectedOption, taskId) => {
        setSelectedStataus(prevState => ({
            ...prevState,
            [taskId]: selectedOption ? selectedOption.value : ""
        }));

        try {
            const response = await axiosAuthInstance.put(
                `task/status/${taskId}`,
                {
                    status: selectedOption?.value,
                    isCompleted: selectedOption?.label === "Final Submit" ? true : false
                }
            )
        } catch (error) {
            console.log('error', error)
        }
    };

    useEffect(() => {
        fetchTaskStatus()
    }, [])

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <section>
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                    <BiTask className="h-5 w-5" />
                    Personal Task
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {tasksList?.length > 0 ? tasksList?.map((task) => {
                        const priorityClass = getPriorityColor(task.priority);
                        return (
                            <div key={task._id} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow cursor-pointer">
                                <h5
                                    className="mb-2 text-xl font-medium text-gray-900 truncate max-w-full text-ellipsis overflow-hidden whitespace-nowrap"
                                    onClick={() => handleViewTask(task._id)}
                                    title={task.name}
                                >
                                    {task.name}
                                </h5>
                                <div className='flex justify-between items-start'>
                                    <span className={`px-3 py-1 text-sm rounded-full ${priorityClass}`}>
                                        {task.priority}
                                    </span>
                                    <span className={`py-1 text-sm`}>
                                        {task.company}
                                    </span>
                                </div>
                                <div className='mt-2'><span className='font-medium mr-1'>Status: </span>{task?.status ? task.status : "Not Started Yet"}</div>
                                <Select
                                    id="employee"
                                    value={taskStatus.find((option) => option.value === selectedStatus[task._id])}
                                    onChange={(selectedOption) => handleStatusChange(selectedOption, task._id)}
                                    options={taskStatus}
                                    placeholder="Task Status"
                                    className="react-select-container mt-3"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        )
                    }) : "No Tasks"}
                </div>
            </section>
        </>
    )
}

export default PersonalTask